// Distributor platform constants
export const PLATFORMS = [
  { id: 1, name: "Amuse", value: "amuse" },
  { id: 2, name: "AWAL", value: "awal" },
  { id: 3, name: "Believe", value: "believe" },
  { id: 4, name: "CD Baby", value: "cd_baby" },
  { id: 5, name: "Distrokid", value: "distrokid" },
  { id: 6, name: "Empire", value: "empire" },
  { id: 7, name: "OneRpm", value: "onerpm" },
  { id: 8, name: "STEM", value: "stem" },
  { id: 9, name: "TooLost", value: "toolost" },
  { id: 10, name: "Tunecore", value: "tunecore" },
  { id: 11, name: "United Masters", value: "united_masters" },
  { id: 12, name: "Vydia", value: "vydia" },
  { id: 13, name: "Other", value: "other" },
];

// Get platform by ID
export const getPlatformById = (id: number) => {
  return PLATFORMS.find(platform => platform.id === id);
};

// Get platform by value
export const getPlatformByValue = (value: string) => {
  return PLATFORMS.find(platform => platform.value === value);
};
